'use client';

import { useState } from 'react';
import { WaitlistDialog } from '@/components/marketing/WaitlistDialog';

interface JoinWaitlistButtonProps {
    className?: string;
    label?: string;
}

export function JoinWaitlistButton({ className = '', label = 'Join the Waitlist' }: JoinWaitlistButtonProps) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button onClick={() => setOpen(true)} className={className}>
                {label}
            </button>
            <WaitlistDialog isOpen={open} onClose={() => setOpen(false)} />
        </>
    );
}
